import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import reset from 'styled-reset'
import { injectGlobal } from 'styled-components'
import NavBar from '../components/NavBar'
import oc from '../components/oc'
import {shevy, baseCSS, Footer, NoPrint} from '../components/StyledComponents'

injectGlobal`
  ${reset}
  ${baseCSS}
`

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: `${data.site.siteMetadata.description}` },
      ]} 
    >
      <link href="https://cdn.rawgit.com/noelboss/featherlight/1.7.13/release/featherlight.min.css" type="text/css" rel="stylesheet" />
      <script src="https://code.jquery.com/jquery-latest.js"></script>
      <script src="https://cdn.rawgit.com/noelboss/featherlight/1.7.13/release/featherlight.min.js" type="text/javascript" charset="utf-8"></script>
    </Helmet>

    <NoPrint>
      <NavBar siteTitle={data.site.siteMetadata.title} />
    </NoPrint>
    
    <div>
      {children()}
    </div>
    
    <NoPrint>
      <Footer>
        <p>
          &copy;2018 {data.site.siteMetadata.title} • <small>{data.site.siteMetadata.description}</small>
        </p>
      </Footer>
    </NoPrint>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js